export default "__VITE_ASSET__ce55571a__"